import _cloneDeep from 'lodash/cloneDeep'
import {
  CHANGE_CLIENT_TO_NOTIFICATION_LIST,
  RESET_CLIENT_TO_NOTIFICATION_LIST,
  OPEN_CLIENT_TO_NOTIFICATION_LIST,
  OPEN_WRITE_MESSAGE_MODAL,
  SEND_MESSAGE_REQUESTED,
  SEND_MESSAGE_SUCCESS,
  SEND_MESSAGE_FAILED,
  GET_NOTIFICATIONS_LIST_REQUESTED,
  GET_NOTIFICATIONS_LIST_SUCCESS,
  GET_NOTIFICATIONS_LIST_FAILED,
  CLIENT_DELETED_FROM_THE_LIST,
} from '../actions/actionTypes'

const initialState = {
    clients: [],
    loading: false,
    commonError: '',
    isBack: false,
    openClientToNotificationList: false,
    showWriteMessageModal: false,
    messageSentSuccess: null,
    notificationsList: {},
    deletedClient: '',
}

const notificationReducer = (state = _cloneDeep(initialState), action) => {
  switch (action.type) {
    case CHANGE_CLIENT_TO_NOTIFICATION_LIST:
        return {
            ...state,
            clients: action.payload,
        }
    case RESET_CLIENT_TO_NOTIFICATION_LIST:
        return {
            ...state,
            clients: []
        }
    case OPEN_CLIENT_TO_NOTIFICATION_LIST:
        return {
           ...state,
           openClientToNotificationList: action.payload,
        }
    case OPEN_WRITE_MESSAGE_MODAL:
        return {
           ...state,
           showWriteMessageModal: action.payload,
           commonError: action.payload ? state.commonError : '',
           messageSentSuccess: action.payload ? state.messageSentSuccess : null,
        }
    case SEND_MESSAGE_REQUESTED:
        return {
            ...state,
            loading: true,
            commonError: '',
        }
    case SEND_MESSAGE_SUCCESS:
        return {
            ...state,
            loading: false,
            commonError: '',
            messageSentSuccess: true,
        }
    case SEND_MESSAGE_FAILED:
        return {
            ...state,
            loading: false,
            commonError: action.payload,
            messageSentSuccess: false,
        }
    case GET_NOTIFICATIONS_LIST_REQUESTED:
        return {
            ...state,
            loading: true,
            commonError: '',
        }
    case GET_NOTIFICATIONS_LIST_SUCCESS:
        return {
            ...state,
            loading: false,
            commonError: '',
            notificationsList: action.payload,
        }
    case GET_NOTIFICATIONS_LIST_FAILED:
        return {
            ...state,
            loading: false,
            commonError: action.payload,
        }
    case CLIENT_DELETED_FROM_THE_LIST:  
        return {
            ...state,
            deletedClient: action.payload,
        }
    default:
      return state
  }
}

export default notificationReducer
